// General Permissions
export const AP_PERMISSION = 'accesspoint';
export const SITE_PERMISSION = 'site';
export const TDMA_PERMISSION = 'tdma';
export const ANALYTICS_PERMISSION = 'analytics';
export const REPORTS_PERMISSION = 'reports';
export const LOGS_PERMISSION = 'logentry';
export const MYUSER_PERMISSION = 'myuser';
export const ROLE_PERMISSION = 'rolepermissiongroup';
export const LICENSE_PERMISSION = 'licensedetails';
export const LICENSE_PERMISSION_1 = 'license';
export const TIP_RADIO_PERMISSION = 'tipradio';

// AP Permissions
export const AP_CLIENT_PERMISSION = 'apclients';
export const AP_SSID_PERMISSION = 'apssid';
export const AP_5GHZ_RADIO_PERMISSION = 'ap_5ghz_radio';
export const AP_24GHZ_RADIO_PERMISSION = 'ap_24ghz_radio';
export const AP_DATA_BANDWIDTH_PERMISSION = 'ap_data_bandwidth';
export const AP_SESSION_DURATION_PERMISSION = 'ap_session_duration';
export const AP_CPU_MEMORY_PERMISSION = 'ap_cpu_memory';
export const AP_MAPS_PERMISSION = 'ap_maps';
export const AP_CLIENT_CONNECTIVITY_PERMISSION = 'client_connectivity';
export const ACTIVE_QOE_PER_AP_PERMISSION = 'activeqoe';
export const LATCH_TIME_ACROSS_CLIENTS_PERMISSION = 'latchingtime';
export const AP_ISSUES_PERMISSION = 'ap_issues';
export const AP_APP_USAGE_PERMISSION = 'ap_application_usage';
export const AP_CLIENT_MODELS_PERMISSION = 'ap_client_models';
export const AP_PACKET_CAPTURE_PERMISSION = 'packetcapture';
export const AP_RADIO_PERMISSION = 'apradioeirp';
export const AP_SNAPSHOT_PERMISSION = 'apsnapshot';

// Home Permissions
export const HOME_ISSUES_PERMISSION = 'home_issues';
export const HOME_TOP_PERFORMING_SITES_PERMISSION = 'home_top_performing_sites';
export const HOME_TOP_IMPACTED_SITES_PERMISSION = 'home_top_impacted_sites';
export const HOME_ACTIVE_QOE_PERMISSION = 'home_active_qoe';
export const HOME_DATA_BANDWIDTH_PERMISSION = 'home_data_bandwidth';
export const HOME_AP_MODEL_FIRMWARE_PERMISSION = 'home_ap_model_firmware';
export const HOME_SWITCH_MODEL_FIRMWARE_PERMISSION =
	'home_switch_model_firmware';
export const HOME_CLIENT_MODELS_PERMISSION = 'home_client_models';
export const HOME_CLIENTS_PERMISSION = 'home_clients';

// Site Permissions
export const SITE_5GHZ_RADIO_PERMISSION = 'site_5ghz_radio';
export const SITE_24GHZ_RADIO_PERMISSION = 'site_24ghz_radio';
export const SITE_DATA_BANDWIDTH_PERMISSION = 'site_data_bandwidth';
export const SITE_AP_MODEL_FIRMWARE_PERMISSION = 'site_ap_model_firmware';
export const SITE_AP_MAPS_PERMISSION = 'site_ap_maps';
export const SITE_SWITCH_MAPS_PERMISSION = 'site_switch_maps';
export const SITE_TRAFFIC_PATTERN_PERMISSION = 'site_traffic_pattern';
export const SITE_SWITCH_MODEL_FIRMWARE_PERMISSION =
	'site_switch_model_firmware';
export const SITE_CLIENTS_PERMISSION = 'site_clients';
export const SITE_APPLICATION_USAGE_PERMISSION = 'site_application_usage';
export const SITE_CLIENT_MODELS_PERMISSION = 'site_client_models';
export const SITE_SSID_LOAD_PERMISSION = 'site_ssid_load';
export const SITE_ISSUES_PERMISSION = 'site_issues';
export const SITE_TOP_PERFORMING_APS_PERMISSION = 'site_top_performing_aps';
export const SITE_TOP_IMPACTED_APS_PERMISSION = 'site_top_impacted_aps';
export const SITE_ACTIVE_QOE_PERMISSION = 'site_active_qoe';
export const SITE_RADIO_PERMISSION = 'siteradioeirp'

// Switch Permissions
export const SWITCH_PERMISSION = 'switch';
export const SWITCH_STATS_PERMISSION = 'switchstats';
export const SWITCH_PORTS_PERMISSION = 'switchports';
export const SWITCH_GLOBAL_VLANS_PERMISSION = 'switchglobalvlans';
export const SWITCH_VLANS_PERMISSION = 'switchvlans';
export const SWITCH_MIRRORS_PERMISSION = 'switchmirrors';
export const SWITCH_LINK_AGGREGATION_PERMISSION = 'switchlinkaggregation';
export const SWITCH_ALARM_CONFIG_PERMISSION = 'switchalarmconfig';
export const SWITCH_ALARM_EVENTS_PERMISSION = 'switchalarmevents';
export const SWITCH_FIRMWARES_PERMISSION = 'switchfirmwares';
export const SWITCH_GLOBAL_CONFIG_PERMISSION = 'switchglobalconfig';

// SSID and Network Permissions
export const GLOBAL_SSID_PERMISSION = 'globalssid';
export const GLOBAL_MAC_ACL_PERMISSION = 'globalmacacl';
export const VLAN_POOLING_PERMISSION = 'vlanpooling';
export const SSID_SCHEDULE_PERMISSION = 'ssidschedule';
export const NAT_CONFIG_PERMISSION = 'natconfig';
export const MULTI_PSK_PERMISSION = 'multipsk';
export const ACSS_SCHEDULE_PERMISSION = 'acsschedule';
export const ROLE_BASED_ACL_PERMISSION = 'rolebasedacl';

// Profile and Alarm Permissions
export const ATF_PROFILE_PERMISSION = 'atfprofile';
export const EOGRE_PROFILE_PERMISSION = 'eogreprofile';
export const ACTIVE_ALARM_PERMISSION = 'activealarm';
export const HISTORICAL_ALARAM_PERMISSION = 'historicalalarm';
export const ALARM_CONFIG_PERMISSION = 'alarmconfig';
export const SNMP_PROFILE_PERMISSION = 'snmpconfiguration';

// Firmware and Captive Portal Permissions
export const FIRMWARE_PERMISSION = 'firmware';
export const FIRMWARE_SCHEDULE_PERMISSION = 'schedulefirmware';
export const CP_PERMISSION = 'captiveportal';

export const VIEW_PERMISSION = 'view';
export const ADD_PERMISSION = 'add';
export const CHANGE_PERMISSION = 'change';
export const DELETE_PERMISSION = 'delete';

// Logs & Report Permissions
export const AUDIT_LOGS_PERMISSION = 'logentry';
export const KPI_REPORTS_PERMISSION = 'kpireport';

// Client Permissions
export const CLIENT_DATA_RATE_PERMISSION = 'client_data_rate';
export const CLIENT_APPLICATION_USAGE_PERMISSION = 'client_application_usage';
export const CLIENT_SIGNAL_STRENGTH_PERMISSION = 'client_signal_strength';
export const CLIENT_CONNECTIVITY_ISSUES_PERMISSION =
	'client_connectivity_issues';
export const CLIENT_NETWORK_EXPERIENCE_PERMISSION = 'client_network_experience';
export const CLIENT_APPLICATION_EXPERIENCE_PERMISSION =
	'client_application_experience';
export const CLIENT_ROAMING_PERMISSION = 'client_roaming';
export const CLIENT_STEERING_PERMISSION = 'client_steering';
export const CLIENT_CONNECTIVITY_PERMISSION = 'client_connectivity';

export const PREMIUM_INDEX = 2;
export const PREMIUM_PRO_INDEX = 3;

// Maintenance Backup
export const SYSTEM_BACKUP = 'backuprestore';
export const SENSOR_MODE = 'systemconfig';

// AAA Server Permissions
export const AAA_SERVER_PERMISSION = 'globalradiusserver';

// Global Settings
export const GLOBAL_SETTINGS_PERMISSION = 'systemconfig';

// Feature Permissions
export const CONFIG_MISMATCH = "config_mismatch";
export const DYNAMIC_VLAN = "dynamic_vlan";
export const SNMP_CONFIG = "snmp_configuration";
export const BULK_ACTION_PERMISSION = 'bulkaction'
export const TR_069_PERMISSION = 'tr069';
